// Б.1.d: Рипер trigger.
// «[В начале каждого хода]: создаёт в руке случайную Подпольную модификацию».
// Срабатывает в onTurnStart (вместе с Танаки-passive). Мод берётся из ОБЩЕГО ПУЛА
// фракции (не из колоды игрока). Если рука >= 10 — Мод сгорает.

import { Card } from '../../card.js';
import { cards as cardsSyn } from '../../../data/cards-syntetics.js';

export const HERO_ID = 'syn_uein';

export function riperOnTurnStart(state, playerIdx) {
  const p = state.players[playerIdx];
  if (!p || p.hero?.id !== HERO_ID) return;
  if (p.hero.hp <= 0) return;
  const pool = cardsSyn.filter(c => c.type === 'mod');
  if (pool.length === 0) return;
  const tpl = pool[state.rng.int(pool.length)];
  const card = new Card(tpl);
  card.ownerId = p.id;
  if (p.hand.length >= 10) {
    p.discard.push(card);
    state.log.add(`✨ Рипер [${p.name}]: ${card.name_ru} сгорает (рука полна)`);
  } else {
    p.hand.push(card);
    state.log.add(`✨ Рипер [${p.name}]: +Мод в руку (${card.name_ru})`);
  }
}
